export const getTransactionNumber = () => {
    const today = new Date();
    let now = today.toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
    now = new Date(now);

    let dd = String(now.getDate()).padStart(2, "0");
    let MM = String(now.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    let hh = String(now.getHours()).padStart(2, "0");
    let mm = String(now.getMinutes()).padStart(2, "0");
    let ss = String(now.getSeconds()).padStart(2, "0");

    return `${dd}${MM}${hh}${mm}${ss}`;
};

export const getISTDateTime = () => {
    const today = new Date();
    let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
        timeZone: "Asia/Kolkata",
    };

    let istDateTime = today.toLocaleString("en-US", options);
    return istDateTime;
};

export const getLastMonthFirstDate = () => {
    const today = new Date();
    const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return firstDayLastMonth.toLocaleDateString('en-CA'); // YYYY-MM-DD format
}

export const getTodayDate = () => {
    return new Date().toLocaleDateString('en-CA'); // Returns YYYY-MM-DD
};